<template>
  <div class="sidebar_warp" v-loading="loading" v-show="showConsultMenu">
    <div class="sidebar_main" v-if="show">
      <div class="top cspt" @click="showMod(1)">
        <div class="ico ico-comment"></div>
        <div class="text">留言</div>
      </div>
      <div class="top cspt" @click="showMod(2)">
        <div class="ico ico-call"></div>
        <div class="text">在线咨询</div>
      </div>
      <div class="bottom cspt" @click="gotoTop()">
        <div class="ico ico-top"></div>
      </div>


      <div class="dialog_warp" v-if="showId==2 && isPersonLogin==1">
        <div class="dialog_box">
          <div class="top">
            <div class="consult_title">在线咨询</div>
            <div class="consult_desc">在线咨询时间为周一至周五9:00-17:00</div>
          </div>

          <div class="middle" v-if="feedBacksC != null" v-for="feedBack in feedBacksC">
            <div class="consult_item right">
              <div class="consult_time">{{ feedBack.createTime }}</div>
              <div class="consult_text">
                {{ feedBack.content }}
              </div>

              <img class="consult_img" src="../../assets/image/avatar.png" alt="">
            </div>

            <div class="consult_item left">
              <div class="consult_time">{{ feedBack.updateTime }}</div>
              <div class="consult_text" style="padding-left: 40px;">
                {{ (feedBack.reply != null && feedBack.reply != '') ? feedBack.reply : "暂未有回复" }}
              </div>
              <img class="consult_img" src="../../assets/image/avatar2.png" alt="">
            </div>
          </div>

          <div class="bottom">
            <el-input
                type="textarea"
                :rows="3"
                placeholder="请输入内容"
                v-model="content1"
                resize="none">
            </el-input>

            <div class="send_btn" @click="feedback();">发送</div>
          </div>

          <div @click="closeFun()" class="dialog_close el-icon-close cspt"></div>
        </div>
      </div>

      <div class="dialog_warp feedback" v-if="showId==1 && isPersonLogin==1">
        <div class="dialog_box">
          <div class="top">
            <div class="consult_title white">留言板</div>
          </div>

          <div class="middle" v-if="feedBacks != null" v-for="feedBack in feedBacks">
            <div class="consult_item right">
              <div class="consult_time">{{ feedBack.create_time }}</div>
              <div class="consult_text">
                {{ feedBack.content }}
              </div>

              <img class="consult_img" src="../../assets/image/avatar.png" alt="">
            </div>

            <div class="consult_item left">
              <div class="consult_time">{{ feedBack.update_time }}</div>
              <div class="consult_text" style="padding-left: 40px;">
                {{ (feedBack.reply != null && feedBack.reply != '') ? feedBack.reply : "暂未有回复" }}
              </div>
              <img class="consult_img" src="../../assets/image/avatar2.png" alt="">
            </div>
          </div>

          <div class="bottom">
            <el-input
                type="textarea"
                :rows="3"
                placeholder="留下您的疑问，我们会第一时间回复您。"
                v-model="content"
                resize="none">
            </el-input>

            <div class="send_btn" @click="feedback();">发送</div>
          </div>

          <div @click="closeFun()" class="dialog_close el-icon-close cspt"></div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {getItemWithExpiry} from "@/store/localstoragewithexpire";
import {Message} from "element-ui";
import request from "@/utils/request";

export default {
  mounted() {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created() {
    this.init()
  },
  data() {
    return {
      dialogVisible: false,
      isForgot: false,
      csConfigData: {},
      loading: false,
      messageData: {},
      unReadTotal: 0,
      show: false,
      showId: 0,
      isIpLogin: 0,
      isPersonLogin: 0,
      user: null,
      isLoginStatus: 0,
      content: '',
      content1: '',
      feedBacks: [],
      feedBacksC: [],
      feedType: '留言',
      showConsultMenu:''
    }
  },
  watch: {
    // 监听窗口打开事件
    dialogVisible: {
      immediate: true,
      handler() {
        if (this.dialogVisible) {
          // this.getCsConfig()
        }
      }
    }
  },
  methods: {
    init() {
      this.isIpLogin = getItemWithExpiry("iploginsucc");
      this.isPersonLogin = getItemWithExpiry("isPersonLogin");
      this.user = JSON.parse(sessionStorage.getItem("user"));
      this.isLoginStatus = getItemWithExpiry("isLogin");
      if (this.user != null) {
        let roles = this.user.roles;
        if (roles != null && !(typeof roles === "undefined")) {
          for (let i = 0; i < roles.length; i++) {
            let item = roles[i];
            if (item.roleKey == 'showConsultMenu') {
              this.showConsultMenu = true;
              break;
            }
          }
        }
      }
    },
    gotoTop() {
      this.closeFun()
      window.scrollTo({
        top: 0,
        behavior: "smooth",//平滑滚动
      });
    },
    closeFun() {
      this.showId = 0
    },
    feedback() {
      let subcontent = '';
      if (this.showId == 1) {
        subcontent = this.content;
      } else {
        subcontent = this.content1;
      }
      let data = {
        "content": subcontent,
        "userId": this.user.userId,
        "feedType": this.feedType
      }
      request({
        url: '/api/index/feedback',
        method: 'post',
        params: data
      }).then(res => {
        Message({
          message: '您的留言已收到，会尽快给您回复',
          type: 'success',
          duration: 2 * 1000
        })
        this.closeFun();
      })
    },
    showMod(id_) {
      this.content = '';
      this.content1 = '';
      if (id_ == 1) {
        this.feedType = '留言'
      } else {
        this.feedType = '咨询'
      }
      this.showId = id_
      if (this.isPersonLogin == 0 || this.user == null) {
        Message({
          message: '请先登录，然后在进行其他操作',
          type: 'error',
          duration: 2 * 1000
        })
        return;
      } else if (this.isIpLogin == 1) {
        Message({
          message: '请先切换个人用户登录，然后在进行其他操作',
          type: 'error',
          duration: 2 * 1000
        })
      }
      //当用户是非IP地址登录时，加载过往留言信息
      if (this.isPersonLogin == 1 && this.user != null) {
        let data = {
          "userId": this.user.userId,
          "feedType": this.feedType,
          "pageSize": 2,
        }
        request({
          url: '/api/index/getfeedback',
          method: 'post',
          params: data
        }).then(res => {
          if (id_ == 1) {
            this.feedBacks = res.feedbacks;
          } else {
            this.feedBacksC = res.feedbacks;
          }
        })
      }
    },
    handleScroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 500) {
        this.show = true
      } else {
        this.show = false
      }
      // console.log(scrollTop, '滚动距离')
    },
    onCopy() {
      this.$message({
        message: 'copy success',
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: 'copy error',
        type: 'error'
      });
    },
    gotoMessage() {
//      let token = localStorage.getItem('token')
      let token = getItemWithExpiry('token');
      if (token) {
        this.$router.push('/message')
      } else {
        this.$router.push('/login')
      }

    },
    handleClose() {
    },
    openContact(val_) {
      if (val_) {
        this.isForgot = true
      } else {
        this.isForgot = false
      }
      this.dialogVisible = true
    },
    setMessageNum() {
      messageRemind().then(res => {
        this.messageData = res.result
        this.unReadTotal = this.messageData.unReadNum
      })
    },
    copy(val_) {
      document.execCommand(val_);
      this.$message({
        message: 'copy success',
        type: 'success'
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_warp {
  position: absolute;
  width: 383px;
  height: 585px;
  background: slategray;
  bottom: 0;
  left: -403px;
  border-radius: 20px;
  // overflow: hidden;
  .dialog_box {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;

    .dialog_close {
      position: absolute;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.32);
      top: -32px;
      right: -32px;
      color: #FF8294;
      z-index: 100;
      text-align: center;
      line-height: 32px;
      font-size: 20px;
    }

    .top {
      width: 100%;
      height: 100px;
      background: linear-gradient(345deg, #FF8294 80%, #FFD8DE 100%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 20px 20px 0 0;

      .consult_title {
        width: 212px;
        height: 32px;
        font-size: 16px;
        color: #333333;
        text-align: center;
        background: #ffffff;
        border-radius: 16px;
        line-height: 32px;
      }

      .consult_desc {
        font-size: 12px;
        color: #fff;
        margin-top: 8px;
      }
    }

    .middle {
      flex-grow: 1;
      padding: 12px 30px;
      box-sizing: border-box;
      background: #F3F5F7;

      .consult_item {
        position: relative;
        margin-bottom: 20px;

        .consult_img {
          position: absolute;
          top: -2px;
          right: -10px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
        }

        .consult_text {
          font-size: 14px;
          color: #333333;
        }
      }

      .consult_item.left {
        .consult_img {
          left: -10px;
        }

        .consult_time {
          text-align: right;
        }

        .consult_text {
          font-size: 14px;
          color: #777777;
        }
      }

      .consult_time {
        font-size: 12px;
        color: #AAAAAA;
        padding: 0 10px;
        margin-bottom: 2px;
      }

      .consult_text {
        min-height: 78px;
        padding: 20px 24px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 10px;
      }
    }

    .bottom {
      width: 100%;
      flex-shrink: 0;
      height: 140px;
      background: #fff;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      padding: 14px 20px 0;
      box-sizing: border-box;
      border-radius: 0 0 20px 20px;

      .send_btn {
        width: 76px;
        height: 30px;
        background: #FF8193;
        border-radius: 8px;
        text-align: center;
        line-height: 30px;
        font-size: 12px;
        color: #fff;
        margin-top: 10px;
      }
    }
  }
}

.dialog_warp.feedback {
  .dialog_box {
    .top {
      height: 72px;
      background: #FFFFFF;

      .consult_title {
        color: #fff;
        background: linear-gradient(170deg, #FFC4CC 0%, #FF8193 15%);
      }
    }
  }
}

.sidebar_main {
  position: fixed;
  bottom: 150px;
  right: 28px;
  width: 108px;
  // height: 146px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  box-shadow: -2px 3px 11px rgba(0, 0, 0, 0.1);
  z-index: 10000;
  border-radius: 10px;
  // overflow: hidden;
  .ico {
    display: inline-block;
    width: 40px;
    height: 40px;
  }

  .ico-comment {
    position: relative;
    background: url("../../assets/image/icon-1.png") no-repeat center/100%;
    // margin-bottom: 28px;
    .message {
      position: absolute;
      display: inline-block;
      width: 22px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      top: -7px;
      right: -7px;
      background-color: #EE263D;
      border-radius: 50%;
      font-size: 14px;
      color: #ffffff;
      opacity: 0.7;
    }
  }

  .ico-call {
    background: url("../../assets/image/icon-2.png") no-repeat center/100%;
  }
}

.top {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 108px;
  height: 108px;
  justify-content: center;

  .text {
    margin-top: 6px;
    font-size: 16px;
    color: #AF67B3;
  }

  &:hover {
    background: #B36AB4;

    .ico-comment {
      position: relative;
      background: url("../../assets/image/icon-1-active.png") no-repeat center/100%;
    }

    .ico-call {
      background: url("../../assets/image/icon-2-active.png") no-repeat center/100%;
    }

    .text {
      color: #fff;
    }
  }
}

.top:first-child {
  border-radius: 10px 10px 0 0;
}

.bottom {
  width: 108px;
  height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0 0 10px 10px;

  .ico-top {
    width: 34px;
    height: 18px;
    background: url("../../assets/image/icon-3.png") no-repeat center/100%;
  }

  &:hover {
    background: #B36AB4;

    .ico-top {
      background: url("../../assets/image/icon-3-active.png") no-repeat center/100%;
    }
  }
}
</style>